export const AllScoreRoutes = {
  index: "/score",
};
